import { TEXT } from '../../../../constants';

export const BUSINESS_FILTER_CLASS = 'business-filter';
export const IMPRESSION_CONFIG = {
    DOMSelector: `.${BUSINESS_FILTER_CLASS}`,
    getImpressionData: () => ({
        type: 'business_filter_is_shown',
        page: {
            element: {
                type: TEXT,
            },
            component: {
                name: 'reviews_header',
            },
        },
        feature: {
            name: 'gig_reviews',
        },
    }),
};
